import * as React from "react"

/**
 * Shared "which chart is expanded in the Detail overlay" state.
 * Lives outside React so AEGIS `#id` clicks on the map view can open the
 * chart dialog even when the Detail tab (and its panel) is not mounted.
 */
let expandedChartId: number | null = null
const listeners = new Set<() => void>()

function notify(): void {
  listeners.forEach(listener => {
    try {
      listener()
    } catch {
      // Listener errors must not abort the rest of the subscribers.
    }
  })
}

export function getExpandedChartId(): number | null {
  return expandedChartId
}

export function setExpandedChartId(nodeId: number | null): void {
  if (expandedChartId === nodeId) {
    return
  }
  expandedChartId = nodeId
  notify()
}

export function subscribeExpandedChartId(callback: () => void): () => void {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}

export function useExpandedChartId(): [number | null, (nodeId: number | null) => void] {
  const [nodeId, setNodeId] = React.useState<number | null>(getExpandedChartId)
  React.useEffect(
    () =>
      subscribeExpandedChartId(() => {
        setNodeId(getExpandedChartId())
      }),
    []
  )
  return [nodeId, setExpandedChartId]
}
